<svg
  class="switching-chevron"
  [style.--size.px]="size()"
  [style.--dur.ms]="animationDur()"
  [class.switching-chevron--down]="pointingDown()"
  [class.switching-chevron--up]="pointingUp()"
  viewBox="0 0 24 24"
>
  <g stroke="currentColor" [attr.stroke-width]="strokeWidth()">
    <line class="line line--1" x1="4.5" y1="12" x2="12" y2="12" />
    <line class="line line--2" x1="19.5" y1="12" x2="12" y2="12" />
  </g>
</svg>
